
export class User {
    id: number=undefined
    access_token=undefined

    username: string
    password:string
    passwordConfirmation:string
    roleGroup: string
    token?: string
    enabled:false
    accountLocked:true
    forcePasswordChange:false
    server_guardian_id:0
    server_student_id:0
    guardian_student_status:0
    server_user_id:0
    vcode: number=0
    reason: string=""
    firstname :string
    lastname :string

    officeNumber:string
    mobileNumber:string

    formData(){
      let body = new URLSearchParams();

      body.set('firstName', this.firstname);
      body.set('lastName', this.lastname);
      body.set('officeNumber', this.officeNumber);
      body.set('mobileNumber', this.mobileNumber);
      body.set('password', this.password);
      body.set('passwordConfirmation', this.passwordConfirmation);
      body.set('username', this.username);
      body.set('vcode', this.vcode.toString());
      body.set('enabled', this.enabled?.toString());
      body.set('accountLocked', this.accountLocked?.toString());
      body.set('forcePasswordChange', this.forcePasswordChange?.toString());
      body.set('id',this.id?this.id.toString():"");


      return body.toString()
    }


    regData(){
      let body = new URLSearchParams();
      body.set('firstName', this.firstname);
      body.set('lastName', this.lastname);
      body.set('officeNumber', this.officeNumber);
      body.set('mobileNumber', this.mobileNumber);
      body.set('password', this.password);
      body.set('passwordConfirmation', this.passwordConfirmation);
      body.set('username', this.username);
      body.set('reason',this.reason);

      return body.toString()
    }
}

